import React, { useEffect, useId, ReactNode, useState } from 'react';
import '../../../styles/components/_modal.scss';
import { CancelBtn, OkBtn } from './Buttons';

interface ModalProps {
  isOpen: boolean;
  title: string;
  content: ReactNode;
  onConfirm: () => Promise<void> | void;
  onCancel: () => void;
  // If true, clicking the overlay will cancel/close the modal. Set to false to
  // prevent accidental closes (useful for drag-and-drop interactions inside modal).
  closeOnOverlayClick?: boolean;
  // Optional additional class to append to the header element (e.g. 'modal__header--danger')
  headerClass?: string;
  okButtonLoading? : boolean;
  cancelButtonLoading? : boolean;
}

const Modal: React.FC<ModalProps> = ({
  isOpen,
  title,
  content,
  onConfirm,
  onCancel,
  closeOnOverlayClick = true,
  headerClass,
  okButtonLoading = false,
  cancelButtonLoading = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const titleId = useId();

  useEffect(() => {
    if (isOpen) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalStyle;
      };
    } else {
      document.body.style.overflow = 'visible'; 
    }
  }, [isOpen]);

  if (!isOpen) {return null;}

  return (
    <div className="modal">
      <div
        className="modal__overlay"
        onClick={closeOnOverlayClick ? onCancel : undefined}
        onKeyDown={closeOnOverlayClick ? (e) => {
          if (e.key === 'Escape') {
            e.preventDefault();
            onCancel();
          }
        } : undefined}
        onDragOver={(e) => e.preventDefault()}
        onDrop={(e) => e.preventDefault()}
      ></div>
      <div
        className="modal__content"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
      >
        <div className={`modal__header modal__header--acknowledge ${headerClass ?? ''}`}>
          <h2 id={titleId} className="modal__title">{title}</h2>
          <button
            className="btn__close se-icon--close"
            onClick={onCancel}
            aria-label="Close modal"
          >

            </button>
        </div>

        <div className="modal__body pb-1">
          {content}
          </div>

        <div className="modal__footer">
          <OkBtn onOk={onConfirm} isLoading={okButtonLoading} />
          <CancelBtn onCancel={onCancel} isLoading={cancelButtonLoading} />
        </div>
      </div>
    </div>
  );
};

export default Modal;
